import { Star, Quote } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { TESTIMONIALS } from '../../data/content';

const Testimonials = () => (
  <section className="bg-mist py-24 md:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        index="11"
        overline="Testimonials"
        title="Real Guidance. Real Career Decisions."
        description="Hear from students and professionals who found their direction with CareerWithRaaj."
      />

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.07 * i} className="h-full">
            <figure
              className="flex h-full flex-col rounded-3xl border border-line bg-white p-7 shadow-card transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-card-hover"
              data-testid={`testimonial-${t.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-coral text-coral" />
                  ))}
                </div>
                <Quote className="h-5 w-5 text-line" />
              </div>
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-600">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-bold text-navy">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
                <span className="ml-auto rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-slate-400">
                  Sample
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 text-center text-xs text-slate-400">
          Sample testimonials shown as placeholders — real stories will be added as students share their journeys.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Testimonials;
